// src/pages/Home.js
import React from "react";
import MobileHeader from "../components/MobileHeader";

// Secciones propias para móviles
import MobileHero from "../mobile/MobileHero";
import MobileHeritage from "../mobile/MobileHeritage";
// Eliminamos MobileReservation ya que ahora se maneja mediante el botón flotante
import MobileLocation from "../mobile/MobileLocation";
import FleetMobile from "../components/FleetMobile";
import MobileServices from "../mobile/MobileServices";
import MobileReviews from "../mobile/MobileReviews";

// Nuevo: Botón flotante de reservación
import MobileReservationButton from "../components/MobileReservationButton";

const Home = () => {
  return (
    <div style={styles.homeContainer}>
      <MobileHeader renderSections={false} />
      
      <div style={styles.sectionsContainer}>
        <MobileHero />
        <MobileHeritage />
        <MobileLocation />
        <FleetMobile />
        <MobileServices />
        <MobileReviews />
      </div>
      
      {/* Botón flotante para reservar */}
      <MobileReservationButton />
    </div>
  );
};

const styles = {
  homeContainer: {
    margin: 0,
    padding: 0,
    minHeight: "100vh",
    overflowX: "hidden",
    fontFamily: "Segoe UI, Tahoma, sans-serif",
    boxSizing: "border-box",
  },
  sectionsContainer: {
    marginTop: "100px",
    padding: "0 16px",
    width: "100%",
    boxSizing: "border-box",
  },
};

export default Home;
